import type { ReactNode } from "react";

export function EmptyState({
  icon,
  title,
  body,
  primary,
  secondary,
}: {
  icon?: ReactNode;
  title: string;
  body?: string;
  primary?: ReactNode;
  secondary?: ReactNode;
}) {
  return (
    <div className="mt-8 rounded-2xl border border-dashed border-line bg-surface px-6 py-12 text-center">
      {icon ? <div className="mx-auto mb-3 flex justify-center">{icon}</div> : null}
      <p className="text-base font-medium text-ink">{title}</p>
      {body ? <p className="mt-2 text-sm text-muted">{body}</p> : null}
      {primary || secondary ? (
        <div className="mx-auto mt-6 flex max-w-xs flex-col gap-2 sm:max-w-none sm:flex-row sm:justify-center [&>*]:w-full sm:[&>*]:w-auto">
          {primary}
          {secondary}
        </div>
      ) : null}
    </div>
  );
}
